export { PromotionDetailPage } from './view/promotion-detail-page';
